import React, { useState } from 'react';
import './comments.scss';
import { v4 as uuidv4 } from 'uuid';
import { formateDateToLocaleStringWithTime } from 'home/view/upgrade-order/utils';

const comments = ({ comments, remarks = [], disabled }) => {
  const [isActive, setActive] = useState(false);

  const handleToggle = () => {
    setActive(!isActive);
  };

  const renderCommentsList = (commentHistory) => {
    const comments = remarks.slice(1).concat(commentHistory);
    if (Array.isArray(comments)) {
      return comments.map(({ name, assignedToRole, userRemarks, requestClosedAt, remarks, submitAt, userType }, index) => {
        return (
          <li key={uuidv4()}>
            <div className="inside_comments">
              <div className="title_text"> {`${assignedToRole ? assignedToRole : 'User'}: ${name ? name : userType ? userType : assignedToRole}`}</div>
              <div className="content_text"> {`${formateDateToLocaleStringWithTime(requestClosedAt ? requestClosedAt : submitAt)}: ${userRemarks || remarks}`}</div>
            </div>
          </li>
        );
      });
    }
    return [];
  };
  return (
    Array.isArray(comments) &&
    comments.length > 0 && (
      <div className={`${'comments_accordion'} ${isActive ? 'active' : ''}`} disabled={disabled}>
        <div className="accordion_title">
          <strong>{isActive ? 'Hide Comments' : 'View All Comments'}</strong>
          <span className="animatedarrow" onClick={handleToggle}></span>
        </div>
        <div className="comments_content">
          <ul class="comments_list">{renderCommentsList(comments)}</ul>
        </div>
      </div>
    )
  );
};

export default comments;
